export const CONSTANTS = {
  EMAIL_REGEX:
    /^(?!.*@.*@)[a-zA-Z0-9](([\x21-\x7E][^<>()\[\]\\.,;:\s@"][\x21-\x7E]+(\.[^<>()\[\]\\.,;:\s@"][\x21-\x7E]+)*)|(".+"))@[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
  UNITS: "Unit",
  ACCESS_POINT: "AccessPoint",
  DASHBOARD: "dashboard",
  LOCATIONS: "locations",
  USERS: "users",
  HOME_ACCESS: "homeAccess",
  OTHER_ACCESS: "otherAccess",
  TEMPORARY_ACCESS: "temporaryAccess",
  HYPHEN: "-",
  INCREMENT: "increment",
  DECREMENT: "decrement",
  RESET: "reset",
  ACTIVITY: "activity",

  FP_STEP_RESET: "Forgot Password Step Reset",
  FP_STEP_ONE: "Forgot Password Step One",
  FP_STEP_TWO: "Forgot Password Step Two",
  FP_STEP_THREE: "Forgot Password Step Three",

  // Role Names
  PROPERTY_MANAGER_ADMIN: "Property Manager Admin",
  PROPERTY_MANAGER_USER: "Property Manager User",
  INSTALLER_ADMIN: "Installer Admin",
  RESIDENT: "Resident",
  INSTALLER_USER: "Installer User",
  DEFAULT_USER: "Default User",
  END_USER: "End User",
  END_USER_HYPHEN: "End-User",

  SITE: "Site Management",
  BUILDING: "Building Management",
  FLOOR: "floor Management",
  UNIT_MANAGAEMENT: "Unit Management",
  REMOVE_UNIT: "Remove Unit",
  EDIT_UNIT: "Edit Unit",
  FILTER_UNIT: "Filter Unit",
  EDIT_MASTER_CREDENTIAL: "Edit Master Credential",
  MASTER_CREDENTIAL: "Master Credential",
  MASTER_CREDENTIAL_DETAIL: "Master Credential Detail",
  UNIT: "Unit",
  ACCESSPOINT: "Accesspoint",
  PENDING_DEACTIVATION: "PENDING_DEACTIVATION",
  ACTIVATED: "ACTIVATED",
  READER: "Reader",
  COMBO_READER: "Combo Reader",
  CONTROLLER: "Controller",
  DOOR: "Door",
  CREATE_USER: "create-user",
  ADD_USER: "add-user",

  // details & activity toggle
  DETAILS: "DETAILS",
  ACTIVITY: "ACTIVITY",
  CREATE: "create",
  UPDATE: "update",
  VIEW: "view",
  DELETE: "delete",

  //ngxOTP Component
  PHONE: "phone",
  VERIFY_CODE: "verifyCode",
  EMAIL: "email",
  LOGIN: "login",
  MOBILE_SMS: "mobile-sms",
  PASSWORD: "password",

  //Login component
  INVALID: "INVALID",
  TYPE_EMAIL: "Email",
  TYPE_PHONE: "Phone",

  //Building Unit Details Component
  LOCK: "Lock",
  LOCKS: "locks",
  USERS: "users",
  DEVICE: "device",
  ACTIVITY_DETAIL: "activity Detail",
  PROFILE_IMAGE_LOADER: "assets/svg/image-loader.gif",

  // Shared data
  SHARED_DATA: "shared",
  USER: "user",
  CONFIRM_DIALOG: "confirm dialog",

  //Filter Unit Component
  WING: "Wing",
  FLOOR: "Floor",
  FILTER_BY: "Filter By",
  NOT_SELECTED: "notSelected",
  SELECTED: "selected",
  FLOORS: "Floors",
  WINGS: "Wings",
  RESET_ALL: "resetAll",
  PENDING_DELETE: "PENDING_DELETE",
  REMOVE: "REMOVE",
  ADD: "ADD",
  EDIT: "EDIT",
  FLOOR_MANAGEMENT: "floor-management",
  BUILDING_LISTING: "building-listing",

  //Completed Component
  PASSWORD_UPDATED: "Password Updated",
  PENDING_ACTIVATION: "PENDING_ACTIVATION",
  DEACTIVATED: "DEACTIVATED",
  // Modal SCSS Variable
  MID_SCREEN_MODAL: "mid-screen-modal",
  LONG_SCREEN_MODAL: "long-screen-modal",
  FIXED_SCREEN_MODAL: "fixed-screen-modal",
  SITE_SETTINGS_MODAL: "site-settings-modal",
  MASTER_CREDENTIAL_MODAL: "master-credential-modal",
  ADD_LOCK: "add-lock",
  ACCOUNT_SETTING: "account-setting",
  SPACE_ZERO: "space-zero",

  // Entity types
  ENTITY_ACCESS_POINT: "AccessPoint",
  ENTITY_ACCESS_LOCK: "Lock",
  VALID_WEB_ROLES: [
    "Property_Manager_Admin",
    "Property_Manager_User",
    "Property Manager Admin",
    "Property Manager User",
  ],

  //ACCESS
  HOME_ACCESS: "homeAccess",
  ANOTHER_ACCESS: "anotherAccess",
  TEMPORARY_ACCESS: "temporaryAccess",

  //Filter User
  USER_TYPE: "User Type",
  USER_STATUS: "User Status",
  // activity
  LOCKED: "locked",
  UNLOCKED: "unlocked",
  DEVICE_IS_UNLOCKED: "Unlocked",
  DEVICE_IS_LOCKED: "Locked",
  JAM: "jam",

  //Device Setting
  DISABLED: "disabled",
  ENABLED: "enabled",
  OFFLINE: "OFFLINE",
  ONLINE: "ONLINE",
  STATIC_STATE_LOCKED: "STATIC_STATE_LOCKED",
  STATIC_STATE_UNLOCKED: "STATIC_STATE_UNLOCKED",
  SITE_MANAGEMENT: "/site-management",
  DASHBOARD_URL: "/dashboard",
  USER_DASHBOARD: "/dashboard/users/",
  TWO_STEP_VERIFICATION: "two step verification",
  FACE_ID: "face id",
  PUSH_NOTIFICATION: "push notification",

  // dashboard user card
  SHOWINGS: "Showings",
  MAINTENANCE: "Maintenance",
  PRIVATE_EVENTS: "Private Events",
  DASHBOARD_UNIT: "unit",
  SHARED_ACCESS: "sharedAccess",
  DEVICE_ISSUE: "deviceIssue",
  FIRMWARE_UPDATE: "Firmware Update",
  ADMIN: "Admin",
  LOCKTAB: "lockTab",
  DEVICETAB: "deviceTab",
  ISSUES: "issues",
  MAX_CALENDER_YEAR: "2037-12-31",
  PARTNER_DEVICETYPE_DOOR: "Door",
  PARTNER_DEVICE_CONTROLLER: "Controller",
  /* Operations for getUserBySite */
  GET_USERS_BY_SITES_OPERATION_UPDATE: "update",
  GET_USERS_BY_SITES_OPERATION_VIEW: "view",
  NOW: "Now",
  DMU: "DMU",
  IPREADER: "IP Reader",
  DEVICESTATUS: "deviceStatus",
  //FAQ LINK
  HELP_AND_FAQ_LINK: "https://www.kwikset.com/support/customer-service",
  PRIVACY_POLICY_LINK: "https://www.privacy.assaabloydss.com/en/privacy",
  PRIVACY_POLICY_LINK_FRENCH:
    "https://ca.weiserlock.com/fr/politique-de-confidentialite",
  PRIVACY_POLICY_LINK_WEISER:
    "https://www.assaabloy.com/group/en/privacy-center/privacy-notice",
  PRODUCT_LINK: "https://www.kwikset.com/unite",
  PRODUCT_LINK_WEISER: "https://ca.weiserlock.com/products/unite",
  PRODUCT_LINK_FRENCH_WEISER: "https://ca.weiserlock.com/fr/produits/unite",
  SUPPORT_CENTER: "https://www.kwikset.com/support/topics/kwikset-app",
  SUPPORT_CENTER_WEISER: "https://ca.weiserlock.com/support",
  SUPPORT_CENTER_FRENCH_WEISER: "https://ca.weiserlock.com/fr/soutien",
  APPS_LINK: "https://www.kwikset.com/unite/web-mobile-software",
  APPS_LINK_WEISER:
    "https://ca.weiserlock.com/products/unite/unite-web-mobile-software",
  APPS_LINK_FRENCH_WEISER:
    "https://ca.weiserlock.com/fr/produits/unite/logiciel-unite-web-et-mobile",
  TERMS_LINK: "https://www.kwikset.com/legal",
  TERMS_LINK_FRENCH: "https://ca.weiserlock.com/fr/conditions-d-utilisation",
  WEB_ACCESSIBILITY: "https://www.kwikset.com/accessibility-statement",
  WEB_ACCESSIBILITY_WEISER: "https://ca.weiserlock.com/web-accessibility",
  WEB_ACCESSIBILITY_FRENCH_WEISER:
    "https://ca.weiserlock.com/fr/accessibilite-du-web",
  TERMS_OF_SERVICE: "https://www.kwikset.com/smart-locks/eula",
  TERMS_OF_SERVICE_WEISER: "https://ca.weiserlock.com/smart-locks/eula",
  TERMS_OF_SERVICE_FRENCH_WEISER: "https://ca.weiserlock.com/smart-locks/eula",
  HELP_LINK: "https://www.kwikset.com/support",
  HELP_LINK_WEISER: "https://ca.weiserlock.com/support",
  HELP_LINK_FRENCH_WEISER: "https://ca.weiserlock.com/fr/soutien",
  APP_STORE_LINK:
    "https://play.google.com/store/apps/details?id=com.kwikset.multifamily",
  BATTERY_ALARAM_PERCENTAGE: "25",
  ADD_DEVICE_NAME_COMPONENT: "1",
  DEVICE_INFORMATION_COMPONENT: "2",
  DEVICE_ADD_COMPONENT: "3",
  ZERO_PERCENT: "0",
  ONE_PERCENT: "1",
  TEN_PERCENT: "10",
  ELEVEN_PERCENT: "11",
  //AccessPoint-icons
  LOCK_ICON: "ico-lock-yellow.svg",
  UNLOCK_ICON: "ico-unlocked-green.svg",
  UNLOCK_EVENT_ICON: "ico-unlocked-green.svg",
  ONLINE_ICON: "icon-powered-on.svg",
  ALERT_ICON: "ico-alert-red.svg",
  UNKNOWN_ICON: "ico-just-lock.svg",
  UNLOCK_EVENT_ICON: "icon-unlock-state.svg",
  UNLOCK_ICON: "icon-unlock-state.svg",
  //Days
  YESTERDAY: "Yesterday",
  TODAY: "Today",
  //Event Code
  ONLINE_DEVICE_EVENT_CODE: "['10,'15',0x0a]",
  ALERT_DEVICE_EVENT_CODE:
    "['11','16','126', '52', '49','0x07', '0x08', '0x09', '0x17','0x1c',0x1d]",
  UNLOCK_DEVICE_EVENT_CODE: "['48', '61', '87', '60','0xe2','0x02','0x52']",
  LOCKED_UNIT_EVENT_CODE: "['0xe1','0x00','0x51','0x01']",
  UNKNOW_EVENT_UNIT_CODE: "['0x06']",
  ADD_DEVICE_NAME_COMPONENT: "1",
  DEVICE_INFORMATION_COMPONENT: "2",
  DEVICE_ADD_COMPONENT: "3",
  //device status icon
  LOCK_STATUS_ICON: "ico-lock-activity-2x.svg",

  UNLOCK_STATUS_ICON: "ico-unlock-2x.svg",
  LOCK_WITH_ISSUE_STATUS_ICON: "ico-lock-circle-outline-red-2x.svg",
  DEFAULT_STATUS_ICON: "ico-lock-circle.svg",
  ACCESS_POINT_STATUS_ICON: "ico-accesspoint-icon.svg",
  ICO_LOCK_CIRCLE_OUTLINE_RED: "ico-lock-circle-outline-red.svg",
  ICO_LOCK_ACTIVITY: "ico-lock-activity.svg",
  ICO_UNLOCK_ACTIVITY: "ico-unlock.svg",
  USER_GROUP: "USER_GROUP",

  //Filter Active Issues

  SELECT_BUILDING: "SELECT_BUILDING",
  SELECT_FLOOR: "SELECT_FLOOR",
  SELECT_WING: "SELECT_WING",
  SELECT_EVENT_CODE: "SELECT_EVENT_CODE",
  //Phone Number region
  PHONE_NUMBER_REGION: "+1",
  REMOVE_USER_ACCESS: "REMOVE_USER_ACCESS",
  REMOVE_USER: "REMOVE_USER",
  DEFAULT_USER_GROUPS: ["Private Events", "Showings", "Maintenance"],
  MASK_SEVEN_STARIEK: "*******",
  INTERCONNECT: "Interconnect",
  KWIKSET_UNITE_TITLE: "Kwikset UNITE",
  WEISER_UNITE_TITLE: "Weiser UNITE",
  KWIKSET_UNITE_DESCRIPTION:
    "Kwikset UNITE™, a comprehensive yet simple end-to-end multifamily access control solution.",
  WEISER_UNITE_DESCRIPTION:
    "Weiser UNITE™ platform offers seamless access control and connectivity for your multifamily property.",
  KWIKSET_UNITE_FAVICO: "assets/icons/kwikset-favicon.ico",
  WEISER_UNITE_FAVICO: "assets/icons/weiser-favicon.ico",
  KWIKSET_UNITE_BRAND_COVER: "assets/images/kwikset-unite-logo.png",
  WEISER_UNITE_BRAND_COVER: "assets/images/weiser-unite-logo.png",
  KWIKSET_UNITE_LOGO: "assets/images/logo1.png",
  WEISER_UNITE_LOGO: "assets/images/weiser-logo.png",
  KWIKSETUNITE: "KwiksetUnite",
  WEISERUNITE: "WeiserUnite",
  KWIKSETUNITE_GRAPHQL: "kwiksetunite",
  WEISERUNITE_GRAPHQL: "weiserunite",
  KWIKSET_UNITE_UI_PROD_URL: "kwiksetunite.com",
  WEISER_UNITE_UI_PROD_URL: "weiserunite.com",
};
